import { Class } from "@eusoft/webapp-jsx";
import  { formatText } from "@eusoft/webapp-ui";
import type { IStatusFormat } from "../helpers/Format";
import "./StatusTag.scss";



export function StatusTag(options: IStatusFormat) {

    return <div className="status-tag">
        <Class name={options.style} />
        {options.icon}
        <span>{formatText(options.label)}</span>    
    </div>
}

